'use strict'

window.dom_ready = function (fn) {
  if (typeof fn !== 'function') {
    return
  }

  if (document.readyState === 'complete') {
    return fn()
  }

  document.addEventListener('DOMContentLoaded', fn, false)
}

if(!window.orgs_index){
  window.orgs_index = {
    list: [],
    ref: {},
    index: {},
    types: {}
  }
}

if(!window.groups_index){
  window.groups_index = {
    list: [],
    ref: {},
    index: {},
    types: {}
  }
}

import App from './App.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueScrollTo from 'vue-scrollto'
import router from './router'
import store from './components/Store.js'
import Framework from './components/Framework'
import Notifications from './components/vue-notification'
// import { VueEditor } from "vue2-editor"
// import ckeditor from 'ckeditor'
// import VueCkeditor from './components/Editor'

// Vue.use(VueGrapesjs)
// import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import './css/bulma.css'
import './css/main.css'
import './css/icon.css'
// Three.js fps stats, used to benchmark animatoin
// import Stats from './components/FpsGraph'
// global.stats = new Stats()
// global.stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(global.stats.dom)

// console.log('ckeditor', CKEDITOR)
Vue.use(VueResource)
Vue.use(VueScrollTo)
Vue.use(Framework)
Vue.use(Notifications)
// Vue.component('vue-editor', VueEditor)
// Vue.component('vue-editor', VueCkeditor)
// Vue.use(FontAwesomeIcon)

Vue.directive('no-select', function (el) {
  el.onmousedown = function (e) {
    e.preventDefault()
  }
})

// Vue.config.strict = true // strict mode

// VueTouch.config.swipe = {
//   threshold: 100
// }

global.isMobile = function () {
  return parseInt(window.innerWidth) < 768
}

// dev and prod url config

global.protocol = ((window.location.protocol === 'https:') ? 'https:' : 'http:')
global.baseURI = document.getElementsByTagName('base')[0].href

if (process && process.env && process.env.NODE_ENV === 'development') { // for webpack dev environment
  global.app_path = global.protocol + '//localhost/fnepaca/annuaire_new/www/'
}
else {
  // global.app_path = global.protocol + '//partage.fnepaca.fr/annuaire/'
  global.app_path = global.baseURI
}

// console.log('baseURI', global.baseURI + 'oauth2callback.html')

// global.orgs_loaded = false
// global.attributes_loaded = false
// global.services_loaded = false
// global.groups_loaded = false

global.oauth_redirect_uri = global.baseURI + 'oauth2callback.html'

window.oauth2callback = function (params) {
  Vue.http.post(global.app_path + 'oauth2callback.php?action=set_account&' + params,
    {
      redirect_uri: encodeURIComponent(global.oauth_redirect_uri),
      token: global.token
    },
    {
      // emulateJSON: true
    })
  .then((response) => {
    console.log(response)

    // alert('response')

    // Vue.$notify({
    //   group: 'auth',
    //   type: 'success',
    //   // type: 'warn',
    //   position: 'top center',
    //   duration: 10000,
    //   'animation-type': 'velocity',
    //   text: 'Votre compte a bien été mis à jour'
    // })
    store.dispatch('get_accounts')
  }, (response) => {
    // error callback
  })
}

// index hot reload

// global.orgs_index_url = '/annuaire/js/orgs_index.js'
// global.groups_index_url = '/annuaire/js/groups_index.js'
// global.orgs_index_url = global.app_path+'/orgs_index.js'
// global.groups_index_url = global.app_path+'/groups_index.js'

global.orgs_index_url = global.app_path+'/indexes.php?action=get_orgs'
global.groups_index_url = global.app_path+'/indexes.php?action=get_groups'

global.hashCode = function (str) {
  var hash = 0, i, chr
  if (str.length === 0) return hash
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return -hash
}

var script_count = 0

global.loadScript = function (src, callback) {
  var script_id = 'script_' + global.hashCode(src)
  var s = document.getElementById(script_id)
  var r = false

  if (s) {
    s.parentNode.removeChild(s)
  }

  s = document.createElement('script')
  s.type = 'text/javascript'
  s.id = script_id
  // s.src = src
  s.src = src + '?' + new Date().getTime()
  document.body.append(s)

  if (callback) {
    s.onload = s.onreadystatechange = function () {
      if (!r && (!this.readyState || this.readyState === 'complete')) {
        r = true
        callback()
      }
    }
  }
}

// global.loadScript(global.orgs_index_url);
// global.loadScript(global.groups_index_url);

// Authorization & index reload interceptors
global.token = localStorage.getItem('id_token')
if(token) {
  var token_parts = token.split('.')

  if (token_parts.length === 3) {
    let token_data_str = atob(token_parts[1])
    let token_data = JSON.parse(token_data_str)
    let expiration_time = Number(token_data.exp) * 1000
    let rights = Number(token_data.rights)
    let univers = Number(token_data.univers)
    global.univers = parseInt(univers)
    global.rights = parseInt(rights)
  }

}

Vue.http.interceptors.push(function (request, next) {
  // global.token = localStorage.getItem('id_token')

  // if (global.token) {
    // request.headers.set('Authorization', 'Bearer ' + id_token)
    // request.params['token'] = global.token
  // }
  // console.log('request', request)

  // continue to next interceptor
  next(function (response) {
    // console.log('ok response', response)
    switch (response.status) {
      case 401:
        localStorage.removeItem('id_token')
        store.commit('SetLogged', false)
        // console.log('router', router)
        if(router.history.current.path != "/login"){
          router.replace('/login')
        }
        break
      default:
        let token_str = response.body.token
        let univers = response.body.univers
        let rights = response.body.rights

        if (token_str) {
          global.token = token_str

          // store.commit('SetToken', token_str)
          // store.commit('SetUnivers', univers)
          // store.commit('SetRights', rights)

          // console.log('response.body', response.body)

          // store.commit('SetToken', token_str)

          let token_parts = token.split('.')

          if (token_parts.length === 3) {
            let token_data_str = atob(token_parts[1])
            let token_data = JSON.parse(token_data_str)
            let expiration_time = Number(token_data.exp) * 1000
            let rights = Number(token_data.rights)
            let univers = Number(token_data.univers)
            global.univers = parseInt(univers)
            global.rights = parseInt(rights)

            // state.rights = rights
            // state.univers = univers
            // state.token = token
            localStorage.setItem('id_token', token_str)
            localStorage.setItem('univers', global.univers)
            localStorage.setItem('rights', global.rights)
            localStorage.setItem('id_token_expiration', expiration_time)
          }

          store.commit('SetLogged', true)
        }

        if (response.body && response.body.index_rebuild) {
          if (response.body.index_rebuild === 'group') {
            window.groups_index = response.body.groups
            store.commit('SetGroupsIndex', response.body.groups)
          }
          else {
            window.orgs_index = response.body.orgs
            store.commit('SetOrgsIndex', response.body.orgs)
          }
        }
      break
    }
  })
})

router.beforeEach(function (to, from, next) { // important
  if (typeof to.params.type !== 'undefined') {
  // console.log('SetType', to.params.type)
    store.commit('SetType', to.params.type)
  }

  if (!store.state.logged && to.path !== '/login') {
    next(false)
  }
  else {
    next()
  }
})

if (localStorage.getItem('id_token') !== null) {
  store.commit('SetLogged', true)
  store.commit('SetToken', localStorage.getItem('id_token'))
}

document.addEventListener('visibilitychange', function () {
  if (!store.state.logged) return

  let expiration = Number(localStorage.getItem('id_token_expiration'))
  if (expiration > 0 && expiration < new Date().getTime()) {
    localStorage.removeItem('id_token')
    localStorage.removeItem('id_token_expiration')
    store.commit('SetLogged', false)
    if(router.history.current.path != "/login"){
      router.replace('/login')
    }
  }
})

/* eslint-disable no-new */

new Vue({
  store: store,
  router: router,
  render: h => h(App),
}).$mount('#app')
